import React from "react";
import Layout from "../../../core/layouts/main";
import { DeviceController } from "../../../core/config/controllers/DeviceController";
import { ProductController } from "../../../core/config/controllers/ProductController";
import ProductModal from "./components/ProductModal";
import Storage from "../../../core/config/helpers/Storage";

export default function Devices({ }) {
    const [data, setData] = React.useState([]);
    const [showModal, setShowModal] = React.useState(false);
    const [selected, setSelected] = React.useState({});

    React.useEffect(() => {
        loadDevices()
    }, []);

    function loadDevices() {
        ProductController.List((result) => {
            setData(result);
        });
    }

  React.useEffect(() => {
    Storage.isAuthenticated();
  }, []);

    function handleEdit(device) {
        setSelected(device);
        setShowModal(true);
    }

    return (
        <Layout>
            <div className="content">
                <div className="content-heading">
                    Dispositivos
                </div>

                <div className="block block-rounded block-bordered">
                    <div className="block-header">
                        <div className="block-title">
                            <i className="fas fa-cogs" /> Dispositivos
                        </div>
                        <div className="block-tools">
                            <button className="btn btn-dual" onClick={() => loadDevices()}>
                                <i className="si si-refresh" />
                            </button>
                            <button className="btn btn-dual" onClick={() => setShowModal(true)}>
                                <i className="si si-plus" />
                            </button>
                        </div>
                    </div>
                    <div className="block-content">
                        <table className="table table-striped table-vcenter">
                            <thead>
                                <tr>
                                    <th className="text-center">ID</th>
                                    <th className="d-none d-sm-table-cell">Nome</th>
                                    <th className="d-none d-sm-table-cell">Valor</th>
                                    <th className="d-none d-sm-table-cell">Criado</th>
                                    <th className="d-none d-sm-table-cell">Atualizado</th>
                                    <th className="text-center">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((device) => (
                                    <tr key={device.id}>
                                        <td className="text-center">{device.id}</td>
                                        <td className="d-none d-sm-table-cell">{device.name}</td>
                                        <td className="d-none d-sm-table-cell">{device.price}</td>
                                        <td className="d-none d-sm-table-cell">
                                            {new Date(device.created_at?.toDate()).toLocaleDateString()}
                                        </td>
                                        <td className="d-none d-sm-table-cell">
                                            {new Date(device.updated_at?.toDate()).toLocaleDateString()}
                                        </td>
                                        <td className="text-center">
                                            <button className="btn btn-sm btn-primary" onClick={() => handleEdit(device)}>
                                                <i className="si si-pencil" />
                                            </button>
                                            <button className="btn btn-sm btn-danger" onClick={() => {
                                                if (window.confirm("Tem certeza que deseja excluir este dispositivo?")) {
                                                    ProductController.Delete(device.id).then(() => {
                                                        alert("Dispositivo excluído com sucesso!");
                                                        loadDevices();
                                                    }).catch((error) => {
                                                        alert(`Erro ao excluir dispositivo: ${error.message}`);
                                                    });
                                                }
                                            }}>
                                                <i className="si si-trash" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
            <ProductModal 
                show={showModal}
                onHide={() => setShowModal(false) | setSelected({}) | loadDevices()}
                infos={selected}
            />
        </Layout>
    )
}